import axios from 'axios';
import authHeader from "@/service/AuthHeader";
import getEnvironment from "@/service/Environment";

const API_URL = getEnvironment().API_LOGGED_IN_URL + 'parent';

export default class ParentChildService {
    linkChild(data) {
        return axios.post(API_URL + '/link-child', data, { headers: authHeader() });
    }
    unlinkChild(data) {
        return axios.post(API_URL + '/unlink-child', data, { headers: authHeader() });
    }
    setHibernation(data) {
        return axios.put(API_URL + '/set-hibernation', data, { headers: authHeader() });
    }
    getChildParents(childId) {
        return axios.get(API_URL + `/child-parents/${childId}`, { headers: authHeader() });
    }
    searchUsers(query) {
        return axios.get(API_URL + `/search-users?q=${encodeURIComponent(query)}`, { headers: authHeader() });
    }
}

